import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { EIGW_FAILURE_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { EIGW_FAILURE_REPORT } from "../interfaces/dashboard";

export default function EigwFailure() {
    const eigwFailureReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.EIGW_FAILURE_REPORT;

    const [eigwFailureReportTableData, setEigwFailureReportTableData] = useState<EIGW_FAILURE_REPORT[]>([]);

    useEffect(() => {
        setEigwFailureReportTableData(EIGW_FAILURE_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="EIGW_FAILURE"
        tableColumns={eigwFailureReportTableColumns}
        tableData={eigwFailureReportTableData} />
    );
}